// uploadApi.js
// Image upload service module for handling file uploads
// Uploads images to server storage (Firebase Storage)
// Returns URL of uploaded image for use in article listings, blog posts, etc.
// Requires authentication token for security

import apiRequest from './api';

// Uploads an image file to the server
// Parameters: file (File object from input), idToken (authentication token)
// Returns URL string of the uploaded image
export async function uploadImage(file, idToken) {
  // Create FormData object to send file as multipart/form-data
  const formData = new FormData();
  formData.append('image', file);

  const payload = await apiRequest('/Upload', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${idToken}`,
      // Do NOT set Content-Type; browser automatically sets it with boundary for FormData
    },
    body: formData,
  });

  return payload?.url;
}